/* eslint-disable no-unused-vars */
var Lightpick = require('../contactUs/lightpick-original');
var noUiSlider = require('nouislider');
var moment = require('moment');
const { find, debounce } = require('lodash');
var formValidation = require('../components/formValidation');
var createErrorNotification = require('../components/errorNotification');
var scrollAnimate = require('../components/scrollAnimate');
var datePicker;

/**
 * Inits date picker.
 */
function initDatePicker() {
    if (document.getElementById('mpDogBirth')) {
        datePicker = new Lightpick({
            field: document.getElementById('mpDogBirth'),
            singleDate: true,
            minDate: moment().subtract(25, 'years'),
            maxDate: moment(),
            locale: {
                buttons: {
                    prev: '<',
                    next: '>'
                }
            },
            weekdayStyle: 'narrow',
            firstDay: 7,
            separator: '/',
            format: 'DD/MM/YYYY'
        });

        $('.calendar-icon').on('click', function (e) {
            e.stopPropagation();
            $('#mpDogBirth').trigger('click');
        });
    }
}

/**
 * Inits select2.
 */
function initalizeSelect2() {
    $('.form-select').select2().select2('destroy').select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: 'select2-dropdown__custom',
        placeholder: $('.form-select').data('placeholder')
    });

    const $breedSelectField = $('.meal-plans-field__breed-wrapper .form-select');
    if ($breedSelectField.length > 0) {
        $breedSelectField.select2().select2('destroy').select2({
            dropdownCssClass: 'select2-dropdown__custom',
            placeholder: $('.form-select').data('placeholder')
        });

        $breedSelectField.on('select2:open', function () {
            const dropdownSearchField = $('.select2-search--dropdown');
            const select = $('.meal-plans-field__breed-wrapper .select2');
            $(dropdownSearchField).addClass('select2-search--dropdown-active');
            select.append(dropdownSearchField);
            select.find('.select2-search__field').attr('placeholder', $('.form-select').data('placeholder-input'));
        });

        $breedSelectField.on('select2:close', function () {
            const dropdownSearchField = $('.select2-search--dropdown');
            $(dropdownSearchField).removeClass('select2-search--dropdown-active');
        });
    }
}

/**
 * Change description for slide selectors.
 */
function updateSelectorInfo() {
    $('.meal-plans-field input[type="radio"]:checked').each(function () {
        var $this = $(this);
        var $conditionInfo = $this.closest('.form-group').find('.condition-info');
        if ($conditionInfo.hasClass('meal-plan-box')) {
            var title = $this.parent('.icon-wrapper').data('title');
            var weight = $this.parent('.icon-wrapper').data('weight');
            var duration = $this.parent('.icon-wrapper').data('duration');
            var recipe = JSON.stringify($this.parent('.icon-wrapper').data('recipe'));
            var editMode = $this.parent('.icon-wrapper').data('editmode');
            var weightText = parseFloat(weight / 1000) + 'kg of Food';
            var durationWeeks = Math.floor(duration / 7);
            var durationDays = duration % 7;
            var durationText = 'Estimated duration of ' + durationWeeks + ' week' + (durationWeeks > 1 ? 's' : '') + (durationDays > 0 ? ' and ' + durationDays + ' day' + (durationDays > 1 ? 's' : '') : '');
            var isSecondBox = $this.parent('.icon-wrapper').data('secondbox');

            // Update price
            var priceUrl = $this.closest('.form-group').find('.box-price').data('priceurl');
            priceUrl = priceUrl.split('?')[0];
            priceUrl = priceUrl + '?recipe=' + recipe + '&duration=' + duration + '&weight=' + weight + (editMode ? '&editMode=true' : '') + '&isSecondBox=' + isSecondBox;
            $this.closest('.form-group').find('.box-price').data('priceurl', priceUrl);
            loadPricePerDay($this.closest('.form-group').find('.box-price'), { title: title, weightText: weightText, durationText: durationText });

        } else {
            $this.closest('.form-group').find('.condition-info__title').text($this.data('label'));
            $this.closest('.form-group').find('.condition-info__description').text($this.data('description'));
        }
    });
}

/**
 * Remove all required attributes. (Prevents default form validation)
 */
function clearRequired() {
    $('.meal-plans-form input, .meal-plans-form select').each(function () {
        $(this).removeAttr('required');
    });
}

/**
* Toggles the submit button on the meal plans form
*/
function toggleSubmitButton() {
    const isProteinSelected = $('.box-field.selected').find('.meal-plans-field__boxoption.active').length > 0;
    const $submitButton = $('.meal-plans-form').find('[type="submit"]');
    $submitButton.prop('disabled', !isProteinSelected);
}

/**
 * Create slide selector.
 */
function createSlider() {
    $('.meal-plans-slider').each(function () {
        var steps = $(this).data('steps');
        var index = $(this).closest('.form-group').find('input[type="radio"]:checked').closest('.icon-wrapper').data('index');
        var start = index * (100 / (steps - 1));

        if (steps > 1) {
            var slider = noUiSlider.create($(this).get(0), {
                range: {
                    'min': 0,
                    'max': 100
                },
                step: (100 / (steps - 1)),
                start: start,
                behaviour: 'tap-drag'
            });

            slider.on('set', function () {
                var value = parseInt(slider.get(), 10);
                var position = value / parseInt((100 / (steps - 1)), 10);
                var $formGroup = $($(this).get(0).target.closest('.form-group'));

                // Clear previous selections.
                $formGroup.find('.condition-icon, .box-option-text, .icon-indicator').each(function () {
                    $(this).removeClass('active');
                    if ($(this).siblings('input').is(':checked')) {
                        $(this).siblings('input').prop('checked', false);
                    }
                });

                // Activate current selection.
                var $iconWrapper = $formGroup.find(`.icon-wrapper[data-index="${parseInt(position, 10)}"]`);
                $iconWrapper.find('input[type="radio"]').prop('checked', true).trigger('click');
                $iconWrapper.find('.condition-icon, .box-option-text, .icon-indicator').each(function () {
                    $(this).addClass('active');
                });

                updateSelectorInfo();
            });
        }
    });
}

/**
 * Progress bar update.
 *
 * @param {String} step - Current quiz step.
 */
function updateProgressBar(step) {
    switch (step) {
        case 'characteristics':
            $('.health-step').removeClass('active');
            $('.nutrition-step').removeClass('active');
            $('.progress-wrapper.quiz').removeClass('d-none');
            $('.progress-wrapper.box').addClass('d-none');
            break;
        case 'health':
            $('.health-step').addClass('active');
            $('.nutrition-step').removeClass('active');
            $('.progress-wrapper.quiz').removeClass('d-none');
            $('.progress-wrapper.box').addClass('d-none');
            break;
        case 'nutrition':
            $('.health-step').addClass('active');
            $('.nutrition-step').addClass('active');
            $('.progress-wrapper.quiz').removeClass('d-none');
            $('.progress-wrapper.box').addClass('d-none');
            break;
        case 'box':
            $('.configuration-step').removeClass('active');
            $('.box-step').addClass('active');
            $('.progress-wrapper.quiz').addClass('d-none');
            $('.progress-wrapper.box').removeClass('d-none');
            break;
        case 'configuration':
            $('.configuration-step').addClass('active');
            $('.box-step').addClass('active');
            $('.progress-wrapper.quiz').addClass('d-none');
            $('.progress-wrapper.box').removeClass('d-none');
            break;
    }
}

/**
 * Collects selected allergy items.
 *
 * @returns Selected items joined together in a single string.
 */
function collectAllergySelections() {
    if ($('input[name="mpStep"]').val() == 'nutrition') {
        $('input.meal-plans-field__allergy').val($('.meal-plans-field__allergy:checked').map(function () {
            return this.value;
        }).get().join());
    }
}

/**
 * Repopulates selected allergy fields.
 */
function selectAllergySelections() {
    if ($('input[name="mpStep"]').val() == 'nutrition') {
        var selectedAllergies = $('.js-mp-allergy').data('selected');
        if (selectedAllergies) {
            selectedAllergies = selectedAllergies.split(',');
            for (var allergy of selectedAllergies) {
                var $field = $(`input.meal-plans-field__allergy[value="${allergy}"]`);
                $field.parent().addClass('active');
                $field.prop('checked', true);
            }
        }
    }
}

/**
 * Reorganizes the page to fit design
 */
function stylePage(quizStep) {
    var $mainContent = $('#maincontent');
    if (quizStep == 'configuration') {
        $mainContent
            .addClass('container')
            .addClass('configuration');

        $mainContent.find('.meal-plans-content')
            .addClass('col-12')
            .addClass('col-lg-7');

        $mainContent.find('.summary-wrapper')
            .appendTo('#maincontent');

        var desktopNav = $mainContent.find('.meal-plans-content > nav');
        var mobileNav = desktopNav.clone().prependTo('#maincontent');

        desktopNav.addClass('d-none').addClass('d-md-block');
        mobileNav.addClass('d-block').addClass('d-md-none');

    } else {
        $mainContent
            .removeClass('container')
            .removeClass('configuration');

        $mainContent.find('.meal-plans-content')
            .removeClass('col-12')
            .removeClass('col-lg-7');

        $mainContent.find('.summary-wrapper').remove();

        $mainContent.children('nav').remove();
        $mainContent.find('.meal-plans-content > nav')
            .removeClass('d-none')
            .removeClass('d-md-block');

        if (quizStep == 'login') {
            $('.progress-wrapper').css({ 'visibility': 'hidden' });
        } else {
            $('.progress-wrapper').css({ 'visibility': 'visible' });
        }
    }

    $('.meal-plans-box-footer').find('.proteins-ingredients').remove();
    $('.meal-plans-box-footer').addClass('d-none');
    if (quizStep == 'box') {
        $('.proteins-ingredients').appendTo('.meal-plans-box-footer');
        $('.meal-plans-box-footer').removeClass('d-none');
    }
}

/**
 * Loads Price per day for boxes
 * Receives params object with duration and weight text to update it synchronously
 */
function loadPricePerDay(priceElem, params) {
    var url = $(priceElem).data('priceurl');
    $.ajax({
        url: url,
        success: function (data) {
            if (data.price) {
                $(priceElem).text(data.price);
            }

            if (data.editMode && data.summary) {
                updateSummary(data.summary);
            }
        }
    }).done(function () {
        if (params && params.title && params.durationText && params.weightText) {
            $(priceElem).closest('.meal-plan-box').find('.box-name').text(params.title);
            $(priceElem).closest('.meal-plan-box').find('.box-weight').text(params.weightText);
            $(priceElem).closest('.meal-plan-box').find('.box-duration').text(params.durationText);
        }
    });
}

/**
 * Handle AJAX call.
 *
 * @param {*} $form - Form element.
 * @param {*} target - Target url.
 * @param {*} data - Serialized form.
 * @param {*} method - Form method.
 */
function handleStepAction($form, target, data, method) {
    $('.response-feedback').empty().hide();
    $.spinner().start();

    $.ajax({
        url: target,
        type: method,
        data: data,
        success: function (response) {
            if (response.renderedTemplate) {
                if (response.quizStep == 'login') {
                    $form.parent().append(response.renderedTemplate);
                    $form.empty();
                } else {
                    $form.siblings().remove();
                    $form.empty().html(response.renderedTemplate);
                    if (!response.validation) {
                        $('.meal-plans-form').find('.form-control.is-invalid').removeClass('is-invalid');
                        $('.meal-plans-form').find('.radio-choose.is-invalid').removeClass('is-invalid');
                        $('.meal-plans-form').find('.invalid-feedback').removeClass('d-flex').addClass('d-none');
                        $('.meal-plans-form').find('.invalid-feedback .alert-text').empty();
                    }
                }
                updateProgressBar(response.quizStep);
                stylePage(response.quizStep);
                clearRequired();
                initDatePicker();
                initalizeSelect2();
                createSlider();
                updateSelectorInfo();
                selectAllergySelections();

                $('.box-price').toArray().forEach(priceElem => {
                    loadPricePerDay(priceElem, null);
                });

                $('.meal-plans').attr('data-step', response.quizStep);
                $('.meal-plans').data('step', response.quizStep);
                $('body, html').animate({
                    scrollTop: 0,
                }, 400);
                $.spinner().stop();

                if (response.quizStep == 'box') {
                    $('input.meal-plans-field__box:not(.customised)').toArray().forEach(box => {
                        calculateBoxPrice($(box).parents('.meal-plans__wrapper').find('.meal-plans-field__boxoption:not(.disabled)').first());
                    });
                }

                // Preload meal plans form
                if (response.validation) {
                    $('.meal-plans-content').removeAttr('style');
                } else {
                    handlePreload();
                }
            } else if (response.redirectUrl) {
                if (response.method) {
                    var newTarget = response.redirectUrl;
                    var newMethod = response.method;
                    var newData = '';
                    if (newMethod == 'POST' && response.csrf) {
                        $form.find('input[name="' + response.csrf.tokenName + '"]').val(response.csrf.token);
                        newData = $form.serialize();
                    }
                    handleStepAction($form, newTarget, newData, newMethod);
                } else {
                    window.location.href = response.redirectUrl;
                }
                $.spinner().stop();
            } else if (response.error) {
                $('.response-feedback').show().append(response.renderedMessage);
                scrollAnimate($('.response-feedback'));
                $.spinner().stop();
            }
        },
        error: function (err) {
            console.log(err);
            if (!err.responseJSON.loggedin && err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
            $.spinner().stop();
        }
    });
}

/**
* Handles the preloading of meal plans form and URL manipulation
*/
function handlePreload() {
    const urlParams = new URLSearchParams(window.location.search);
    const isPreload = !!urlParams.get('preload');
    const mpStep = $('[name=mpStep]').val();
    const $mainContent = $('.meal-plans-content');
    const $form = $('.meal-plans-form');

    if (isPreload) {
        $mainContent.css('opacity', 0);
        $form.trigger('submit');
    }

    if (mpStep === 'nutrition') {
        urlParams.delete('preload');
        window.history.replaceState({}, document.title, `${window.location.pathname + (urlParams.size > 0 ? '?' + urlParams.toString() : '')}`);
    }

    if (['box', 'login'].indexOf(mpStep) > -1) {
        $mainContent.removeAttr('style');
    }
}

function updateSummary(data) {
    var rewardPointsApplied = data.rewardPointsDiscount != null;

    if (rewardPointsApplied) {
        $('.reward-discount-price').find('.price-value').text(data.rewardPointsDiscount);
        $('.reward-discount-price').removeClass('d-none').addClass('d-flex');

        $('.js-reward-points-applied').css('display', 'block');
        $('.js-reward-points-content').css('display', 'none');
    } else {
        $('.reward-discount-price').find('.price-value').text('');
        $('.reward-discount-price').addClass('d-none').removeClass('d-flex');

        $('.js-reward-points-applied').css('display', 'none');
        $('.js-reward-points-content').css('display', 'block');
    }

    $('.sub-total-price').find('.price-value').text(data.subtotal);
    $('.discount-price').find('.price-value').text(data.discounts);
    $('.shipping-price').find('.price-value').text(data.shipping);
    $('.total-price').find('.price-value').text(data.total);
}

function calculateBoxPrice($this) {
    var proteins = [];
    $this.closest('.box-proteins').find('.meal-plans-field__boxoption').toArray().forEach(elem => {
        if ($(elem).hasClass('active')) {
            proteins.push($(elem).data('protein'));
        }
    });
    var box = $this.parents('.meal-plans__wrapper').find('.meal-plans-field__box').attr('name');
    var url = $this.data('url') + '?proteins=' + proteins.join(',') + '&box=' + box;
    $('.response-feedback').empty().hide();
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'POST',
        data: {
            csrf_token: $('input[name="csrf_token"]').val(),
        },
        success: function (data) {
            if (data.success) {
                if (data.pricePerDay) {
                    $this.parents('.meal-plans__wrapper').find('.recipe-price .price-value').empty();
                    $this.parents('.meal-plans__wrapper').find('.recipe-price .price-value').append('<span>' + data.pricePerDay + '</span>');
                    $this.parents('.meal-plans__wrapper').find('.recipe-price .price-value').removeClass('has-discount');

                    if (data.pricePerDayDiscounted) {
                        $this.parents('.meal-plans__wrapper').find('.recipe-price .price-value').append('<span class="discounted-price">' + data.pricePerDayDiscounted + '</span>');
                        $this.parents('.meal-plans__wrapper').find('.recipe-price .price-value').addClass('has-discount');
                    }
                }

                if (data.disabledProteins) {
                    // Enable all
                    $('.meal-plans-field__boxoption').removeClass('disabled');

                    var disabledProteins = data.disabledProteins;
                    disabledProteins.forEach(disabledProtein => {
                        var targetProtein = $('div[data-protein="' + disabledProtein + '"]');
                        var input = targetProtein.find('input');

                        targetProtein.addClass('disabled');
                        targetProtein.removeClass('active');
                        input.addClass('disable');
                    });
                }
            } else if (data.error) {
                $('.response-feedback').show().append(data.renderedMessage);
                scrollAnimate($('.response-feedback'));

                $this.toggleClass('active');
                var prop = $this.find('input.form-control.d-none').prop('checked');
                $this.find('input.form-control.d-none').prop('checked', !prop);
            }
            $('input[name="csrf_token"]').val(data.csrf.token);
            $.spinner().stop();
        },
    });
}


module.exports = {
    clearRequired: clearRequired,

    initalizeSelect2: initalizeSelect2,

    createSlider: createSlider,

    updateSelectorInfo: updateSelectorInfo,

    initDatePicker: initDatePicker,

    modalPopupOpen: function () {
        $(document).on('click', 'a.logo-home', function (e) {
            e.preventDefault();
            var target = $(this).data('href');
            $(target).modal('show');
        });
    },

    modalPopupClose: function () {
        $(document).on('click', '.close-modal', function () {
            $(this).closest('.modal').modal('hide');
        });
    },

    forceDateText: function () {
        $(document).on('keypress', '#mpDogBirth', function (e) {
            if (/[0-9]+/.test(e.key)) {
                if ($(this).val().length === 2 || $(this).val().length === 5) {
                    $(this).val($(this).val() + '/');
                }

                return true;
            }

            return false;
        });
    },

    exactBirth: function () {
        $(document).on('click', '.checkbox-container.js-exact-birth-check', function () {
            if ($('#exactBirth').is(':checked')) {
                $('.js-exact-birth').toggleClass('d-none');

                var $years = $('.meal-plans-field__years').find('input');
                var $months = $('.meal-plans-field__months').find('input');
                $years.val('').prop('disabled', !$years.prop('disabled'));
                $months.val('').prop('disabled', !$months.prop('disabled'));
            } else {
                var $birth = $('.js-exact-birth').find('input');
                $birth.val('');
            }
        });
    },

    genderPick: function () {
        $(document).on('click', '.meal-plans-field .gender-button', function () {
            $('.meal-plans-field .gender-button').each(function () {
                $(this).removeClass('active');
            });
            $(this).addClass('active');
            $('input#' + $(this).data('target')).prop('checked', true).trigger('click');
        });
    },

    sliderSelection: function () {
        $(document).on('click', '.condition-icon, .box-option-text', function () {
            var $slider = $(this).closest('.form-group').find('.meal-plans-slider');
            var index = parseInt($(this).closest('.icon-wrapper').data('index'), 10);
            var steps = parseInt($slider.data('steps'), 10);
            var customSlider = $slider.get(0).noUiSlider;
            customSlider.set(index * (100 / (steps - 1)));
        });
    },

    customCheckboxSelection: function () {
        $(document).on('click', '.meal-plans-field__allergy, .meal-plans-field__boxoption:not(.disabled)', function () {
            $(this).toggleClass('active');
            var $checkbox = $(this).find('input[type="checkbox"]');
            if ($checkbox) {
                $checkbox.prop('checked', !$checkbox.prop('checked'));
            }
        });
    },

    mixedBreed: function () {
        $(document).on('change', '#mixedBreed', function () {
            if ($(this).prop('checked')) {
                $(this).closest('.meal-plans-field').find('select.meal-plans-field__breed').val('').trigger('change');
                $('select.meal-plans-field__breed').prop('disabled', true);
            } else {
                $(this).closest('.meal-plans-field').find('select.meal-plans-field__breed').val('').trigger('change');
                $('select.meal-plans-field__breed').prop('disabled', false);
            }
        });
    },

    weightChange: function () {
        $(document).on('click', '.meal-plans-field__condition', function () {
            var currentWeight = $('.meal-plans-field__condition:checked').val();
            var $weightChangeLabel = $('.weight-change-label');
            if (['chubby', 'overweight'].indexOf(currentWeight) > -1) {
                $($weightChangeLabel).closest('.meal-plans-field').removeClass('d-none');
                $weightChangeLabel.text($weightChangeLabel.data('lose'));
            } else if (currentWeight == 'ideal') {
                $($weightChangeLabel).closest('.meal-plans-field').addClass('d-none');
            } else {
                $($weightChangeLabel).closest('.meal-plans-field').removeClass('d-none');
                $weightChangeLabel.text($weightChangeLabel.data('gain'));
            }
        });
    },

    previousForm: function () {
        $(document).on('click', '.back-button a, .js-mealplans-progress .stage.active', function (e) {
            e.preventDefault();
            var $form = $('.meal-plans-form');
            var isCurrentStep = $form.parent().data('step') === $(this).text().trim().toLowerCase();
            if (!isCurrentStep) {
                var target = $(this).data('href');
                var data = $form.serialize();
                var method = $('.back-button a').data('type') || 'GET';
                if (target) {
                    handleStepAction($form, target, data, method);
                } else {
                    var $this = $(this);
                    var hasPrevPageClassname = $this.hasClass('js-back-to-prev-page');
                    if (hasPrevPageClassname) {
                        var defaultLink = $this.data('link');
                        window.location.href = document.referrer || defaultLink;
                    } else {
                        window.location.href = $this.attr('href');
                    }
                }
            }
        });
    },

    nextForm: function () {
        $(document).on('submit', '.meal-plans-form', function (e) {
            e.preventDefault();
            var $form = $(this);
            var target = $('.submit-button button').data('href');
            collectAllergySelections();
            var data = $form.serialize();
            var method = $('.submit-button button').data('type') || 'GET';

            if ($('.meal-plans').data('step') == 'nutrition') {
                // Add empty string for allergies in case none of them are selected
                if ($('.meal-plans-field__allergy:checked').length == 0) {
                    var serializedEmptyAllergy = $('.meal-plans-field__allergy').attr('name') + '=none&';
                    data = serializedEmptyAllergy + data;
                }
            } else if ($('.meal-plans').data('step') == 'box') {
                var $selectedBox = $('.meal-plans__wrapper.selected', $form);
                var boxName = $selectedBox.find('.meal-plans-field__box').attr('name');
                var proteins = [];
                $selectedBox.find('.box-proteins .meal-plans-field__boxoption').toArray().forEach(elem => {
                    if ($(elem).hasClass('active')) {
                        proteins.push($(elem).data('protein'));
                    }
                });
                var boxParams = 'box=' + boxName + '&proteins=' + proteins.join(',');
                if (target.indexOf('?') == -1) {
                    target += '?' + boxParams;
                } else {
                    target += '&' + boxParams;
                }
            } else if ($('.meal-plans').data('step') == 'configuration') {
                var $consecutiveBoxesBtn = $('#box-config-input');
                var $consecutiveBoxSelected = $('input.meal-plans-field__option:checked');

                var configParams = 'configConsecutive=' + $consecutiveBoxesBtn.is(':checked');
                if ($consecutiveBoxesBtn.is(':checked')) {
                    configParams += '&consecutiveBox=' + $consecutiveBoxSelected.val();
                }

                if (target.indexOf('?') == -1) {
                    target += '?' + configParams;
                } else {
                    target += '&' + configParams;
                }
            }

            handleStepAction($form, target, data, method);
        });
    },

    boxSelectionChange: function () {
        $(document).on('change', 'input.meal-plans-field__box', function () {
            $('.box-field').each(function () {
                $(this).removeClass('selected');
                $(this).find('input.meal-plans-field__box').prop('checked', false);
            });
            $(this).prop('checked', true);
            $(this).closest('.box-field').addClass('selected');

            toggleSubmitButton();
        });
    },

    mpRewardPoints: function () {
        $(document).on('click', '.mp-redeem-points, .mp-undo-redeem-points', function (e) {
            e.preventDefault();
            $.spinner().start();

            $.ajax({
                url: $(this).attr('data-action'),
                method: 'POST',
                success: function (data) {
                    if (!data.error) {
                        updateSummary(data);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    rawPercentage: function () {
        $(document).on('click', '.raw-feeding .tab', function () {
            var $this = $(this);
            var $form = $('.meal-plans-form');
            var data = $form.serialize();
            var url = $this.data('href');
            $('.response-feedback').empty().hide();
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'POST',
                data: data,
                success: function (response) {
                    if (response.renderedTemplate) {
                        stylePage('');
                        $form.empty().html(response.renderedTemplate);
                        stylePage(response.quizStep);
                        clearRequired();
                        createSlider();
                        updateSelectorInfo();

                        $('.box-price').toArray().forEach(priceElem => {
                            loadPricePerDay(priceElem, null);
                        });

                        $('.meal-plans').data('step', response.quizStep);
                        $('body, html').animate({
                            scrollTop: 0,
                        }, 400);
                    } else if (response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    } else if (response.error) {
                        $('.response-feedback').show().append(response.renderedMessage);
                        scrollAnimate($('.response-feedback'));
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    boxConfigButtons: function () {
        $(document).on('click', '.box-config-button', function () {
            var $this = $(this);

            if ($this.hasClass('now')) {
                $this.addClass('d-none');
                $('.box-config-consecutive').removeClass('d-none');
                $('.box-config-button.later').removeClass('d-none');
                $('.box-config-input').prop('checked', true);
            }
            if ($this.hasClass('later')) {
                $this.addClass('d-none');
                $('.box-config-consecutive').addClass('d-none');
                $('.box-config-button.now').removeClass('d-none');
                $('.box-config-input').prop('checked', false);
            }
        });
    },

    selectProtein: function () {
        $(document).on('click', '.meal-plans-field__boxoption:not(.disabled)', function () {
            var proteinsLimit = parseInt($(this).parents('.box-proteins').data('proteinslimit'), 10);
            if (proteinsLimit != null) {
                var selectedProteins = $(this).parents('.box-proteins').find('.meal-plans-field__boxoption.active').length;
                if (selectedProteins > proteinsLimit || selectedProteins < 1) {
                    // Revert the un/selection
                    $(this).toggleClass('active');
                    var $checkbox = $(this).find('input[type="checkbox"]');
                    if ($checkbox) {
                        $checkbox.prop('checked', !$checkbox.prop('checked'));
                    }
                } else {
                    calculateBoxPrice($(this));
                    $(this).parents('.meal-plans__wrapper.meal-plans-field.box-field').find('.recipe-price').removeClass('d-none').addClass('d-flex');
                }
            } else {
                calculateBoxPrice($(this));
                $(this).parents('.meal-plans__wrapper.meal-plans-field.box-field').find('.recipe-price').removeClass('d-none').addClass('d-flex');
            }

            toggleSubmitButton();
        });
    },

    handleLogin: function () {
        $(document).on('click', '.js-password-icon', function () {
            var $this = $(this);
            $this.toggleClass('show-password');

            if ($this.hasClass('show-password')) {
                $this.parent().find('input').attr('type', 'text');
            } else {
                $this.parent().find('input').attr('type', 'password');
            }
        });

        $(document).on('submit', '#registered-customer', function (e) {
            e.preventDefault();
            var $form = $(this);
            var data = $form.serialize();
            var method = $form.attr('method');
            var url = $form.attr('action');
            $form.find('.is-invalid').removeClass('is-invalid');
            $form.find('.invalid-feedback').text('');
            $.spinner().start();
            $.ajax({
                url: url,
                type: method,
                data: data,
                success: function (response) {
                    if (response.fieldErrors && response.fieldErrors.length > 0) {
                        // Handle errors in form
                        Object.keys(response.fieldErrors[0]).forEach(fieldName => {
                            $form.find('[name=' + fieldName + ']').addClass('is-invalid');
                            $form.find('[name=' + fieldName + ']').siblings('.invalid-feedback').text(response.fieldErrors[0][fieldName]);
                        });
                        $.spinner().stop();
                    } else if (response.customerErrorMessage) {
                        createErrorNotification('.customer-error', response.customerErrorMessage);
                        $.spinner().stop();
                    } else if (response.customerLoginResult) {
                        if (response.customerLoginResult.error) {
                            $.spinner().stop();
                        } else {
                            $.spinner().stop();
                            // Change the token on form
                            var $mpForm = $('.meal-plans-form');
                            var newToken = response.csrfToken;
                            $mpForm.append('<input name="csrf_token" value="' + newToken + '" hidden>');
                            handleStepAction($mpForm, $('.login-continue-button').data('href'), $mpForm.serialize(), 'POST');
                        }
                    }
                },
                error: function (_response) {
                    $.spinner().stop();
                }
            });
        });

        $(document).on('submit', '.reset-password-form', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block">'
                                    + data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },
    onlyNumbers: function () {
        $(document).on('input', '.numeric-field', function () {
            var currentString = $(this).val();
            var regExpPattern = '[0-9]*';
            if ($(this).hasClass('meal-plans-field__weight')) {
                // Allow dot + decimal (, or .)
                regExpPattern += '([\\.|\\,]?[0-9]{0,2})';
            }
            var regExp = new RegExp('^' + regExpPattern + '$');
            if (!regExp.test(currentString)) {
                $(this).val(currentString.substring(0, currentString.length - 1));
            }
        });
    },

    onlyLetters: function () {
        $(document).on('input', '.text-field', function () {
            if ($(this).attr('id') != 'mpDogName') {
                var currentString = $(this).val();
                // eslint-disable-next-line no-useless-escape
                var regExp = new RegExp('^[a-zA-Z\s]*$');
                if (!regExp.test(currentString)) {
                    $(this).val(currentString.substring(0, currentString.length - 1));
                }
            }
        });
    },

    loadBoxEdit: function () {
        $(function () {
            var $editLoader = $('input.editLoader');
            if ($editLoader.length > 0) {
                var $form = $('form.meal-plans-form');
                var target = $editLoader.data('url');
                var data = $form.serialize();
                var method = 'POST';
                handleStepAction($form, target, data, method);
            }
        });
    },

    dailyDoseChange: function () {
        $(document).on('click', '.daily-feeding .nuggets-quantity button', function () {
            var $this = $(this);

            // Check if it's possible to change the quantity on the desired way;
            var maximum = $(this).parents('.nuggets-quantity').data('maximum');
            var minimum = $(this).parents('.nuggets-quantity').data('minimum');
            var current = $(this).parents('.nuggets-quantity').data('current');
            var limitReached = ($this.data('quantity') == 'minus' && current == minimum) || ($this.data('quantity') == 'plus' && current == maximum);

            if (!limitReached) {
                var $form = $('.meal-plans-form');
                var data = $form.serialize();
                var selectedWeight = $('.box-config-consecutive .icon-wrapper input:checked').parent().data('weight');
                var url = $this.data('href') + '&selectedweight=' + selectedWeight;
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: data,
                    success: function (response) {
                        if (response.renderedTemplate) {
                            stylePage('');
                            $form.empty().html(response.renderedTemplate);
                            stylePage(response.quizStep);
                            clearRequired();
                            createSlider();
                            updateSelectorInfo();

                            $('.meal-plans').data('step', response.quizStep);
                            $('body, html').animate({
                                scrollTop: 0,
                            }, 400);
                        } else if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        }
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    boxFooterMenu: function () {
        $(document).on('click', '.protein-selector', function () {
            var $this = $(this);
            var protein = $(this).data('protein');
            if (!$this.hasClass('active')) {
                $('.protein-selector').removeClass('active');
                $this.addClass('active');
                $('.protein-content').addClass('d-none');
                $('.protein-content[data-protein=' + protein + ']').removeClass('d-none');
            }
        });
    },

    /**
    * A function that handles the interstitial for meal plans
    */
    initInterstitial: function () {
        var $interstitial = $('.mp-prestep-interstitial');
        var $cta = $interstitial.find('.mp-prestep-interstitial__cta');

        if (!$interstitial.length) {
            return;
        } else {
            // Add a class to the body so it can be tracked when an interstitial is active
            $('body').addClass('interstitial__active');
        }

        $cta.on('click', () => {
            // Reactivate mealplans contnt
            $('.meal-plans-content').removeClass('d-none');

            // Deactivate interstitial
            $('body').removeClass('interstitial__active');

            // Remove interstitial from DOM
            $interstitial.remove();

            // Autoscroll to top
            $('html, body').animate({
                scrollTop: 0,
            }, 400);
        });

    },

    preload: function () {
        handlePreload();
    },
};
